import { render } from "./ImageDetailView.vue?vue&type=template&id=11643e17"
import script from "./ImageDetailView.vue?vue&type=script&lang=js"
export * from "./ImageDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__